import SvgIcon, { SvgIconProps } from '../components/SvgIcon';

interface Props extends SvgIconProps {}

const PollIcon = ({ ...props }: Props) => {
  return (
    <SvgIcon
      width={60}
      height={61}
      viewBox="0 0 60 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_503_1979)">
        <rect x="6" y="6.5" width="48" height="8" rx="2" fill="currentColor" />
        <rect x="6" y="18.5" width="32" height="8" rx="2" fill="currentColor" />
        <rect x="6" y="30.5" width="24" height="8" rx="2" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_503_1979">
          <rect width="48" height="48" fill="currentColor" transform="translate(6 6.5)" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default PollIcon;
